import { Injectable } from '@angular/core';
import { ApiHttp } from 'app/providers';

@Injectable()
export class AuthService {
    constructor(private apiHttp: ApiHttp) {
    }

    public login(apiUrl: string, data: any): Promise<any> {
        return fetch(apiUrl + 'Login', {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    }

    public checkOneTimePassword(checkOtpApiUrl: string, processId: string, password: string = '112233'): Promise<any> {
        const dto = {
            ProcessId: processId,
            Password: password // Password 112233 is set for web admin
        };

        return fetch(checkOtpApiUrl, {
            method: 'POST',
            body: JSON.stringify(dto),
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    //Call api token with ProcessId for get auth data
    token(tokenApiUrl: string, processId: string): Promise<any> {
        return fetch(tokenApiUrl, {
            method: 'POST',
            body: 'processId=' + processId + '&roleId=2',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        });
    }
}
